import React, { useState, useEffect } from 'react';
import { Route, Switch, useParams } from 'react-router-dom';
import ClientStaffDetail from '../TabbedEntity/ClientStaffEditor';
import ManageEntityList from './ManageEntityList';
import { useAuth } from '../../Services/AuthContext';
import ClientModal from '../Models/ClientModal';
import entities from '../../utils/entities';


const ClientStaffList = ({hideActions, admin, client, entity, route, headerHeight, parentHeight, item }) => {
    const params = useParams();
    const { list,clientId,clientDepartmentId, clientAction } = params;
    const [auth] = useAuth();
    const [defaultEntity, setEntity] = useState(entity); 

      useEffect(() => {
          if (!defaultEntity && auth && entities) {
              let entity = admin ? entities.clientStaffAdmin : client && auth.clientId ? entities.clientStaffClient : entities.clientStaff;
            const theClientId = auth?.ClientId ? auth?.clientId : item?.clientMasterId;
            const theClientDepartmentId = auth?.clientDepartmentId ? auth?.clientDepartmentId : clientDepartmentId ? clientDepartmentId : item?.id;
             
            entity.newItem= () => {
                return {
                    clientMasterId: theClientId,
                    clientDepartmentId: theClientDepartmentId,
                    firstName: "",
                    lastName: "",
                    email: "",
                    marginType: "",
                    canViewSupplierInfo: false,
                    status: "Invited",

                }
            }
            setEntity( entity);
        }
        
      }, [auth, clientId, defaultEntity, item, list, clientAction, admin,client,clientDepartmentId]);
    return defaultEntity ? <React.Fragment>
        <ManageEntityList hideActions={hideActions} route={route} item={item ? item : { id: auth.clientId || auth.clientDepartmentId }} itemId={params[defaultEntity.itemParam]} parentHeight={parentHeight} entity={defaultEntity} headerHeight={headerHeight} />
        <Switch>
            <Route path={route + '/:clientStaffId/:staffAction/:list/:activeKey'} render={({ match }) => <ClientModal route={route} entity={defaultEntity} itemParam='clientStaffId' > <ClientStaffDetail route={route} /></ClientModal>}/>
            <Route path={route + '/:clientStaffId/:staffAction/:list'} render={({ match }) => <ClientModal route={route} entity={defaultEntity} itemParam='clientStaffId' > <ClientStaffDetail route={route} /></ClientModal>}/>
            <Route path={route + '/:clientStaffId/:staffAction'} render={({ match }) => <ClientModal route={route} entity={defaultEntity} itemParam='clientStaffId' > <ClientStaffDetail route={route} /></ClientModal>}/>
            <Route path={route + '/:clientStaffId/'} render={({ match }) => <ClientModal route={route} entity={defaultEntity} itemParam='clientStaffId' ><ClientStaffDetail entity={defaultEntity} route={route} /></ClientModal>}/>

        </Switch>
    </React.Fragment> : null;
}
export default ClientStaffList;
